module.exports = __webpack_public_path__ + "static/media/math_pack_characters_only.f79eaed8.png";